module.exports = __webpack_public_path__ + "static/clay-capital-logo-19c0dae9b431d012ca2d395499072ab3.svg";